import apiService from './api-service';
import { utilsService } from "./utils-service";
import { filterService } from "./filter-service";

export const fuelTankService = {
	getFuelTanks,
	getFuelTanksInfo,
	getFuelTanksAccountingSystemInfo,
	exportFuelTanks,
	getFuelTankData,
	getFuelTankCard,
	updateFuelTankCard,
	downloadFuelTankCalibration,
	downloadSensorVerificationFile,
	downloadFuelConsumptionSensorVerificationFile
};

async function getFuelTanks() {
	const fuelTanks = await apiService.get('fueltank/getFuelTanks');

	return fuelTanks;
}

async function getFuelTanksInfo() {
	const fuelTanksInfo = await apiService.get('fueltank/getFuelTanksInfo');

	return fuelTanksInfo;
}

async function getFuelTanksAccountingSystemInfo() {
	const fuelTanksInfo = await apiService.get('fueltank/getFuelTanksInfoAccountingSystem');

	return fuelTanksInfo;
}

async function exportFuelTanks(format, headers, name, data, summary) {
	const parameters = {
		format: format,
		headers: headers,
		name: name,
		data: data,
		summary: summary,
		timezoneMinutes: -1 * new Date().getTimezoneOffset()
	}

	const result = await apiService.downloadFile('fueltank/exportFuelTanks', parameters, `${name}.${format}`);

	return result;
}

async function getFuelTankData(beginTime, endTime, selectedValues, selectedFilter, fuelTanks) {
	let tankIds = [];

	if (selectedFilter == filterService.TANK_IDS_FILTER) {
		tankIds = selectedValues.values.map(item => { return item.key });
	} else if (selectedFilter == filterService.COMPANY_ID_FILTER) {
		tankIds = filterService.getFilterValuesByCompanies(fuelTanks, selectedValues).split(",");
	} else if (selectedFilter == filterService.DEPO_FILTER) {
		tankIds = filterService.getFilterValuesByDepos(fuelTanks, selectedValues).split(",");
	}

	const parameters = {
		beginTime: utilsService.formatDateTime(beginTime),
		endTime: utilsService.formatDateTime(endTime),
		tankIds: tankIds
	};

	const fuelTankData = await apiService.post('fuelTank/getFuelTankData', parameters);

	return fuelTankData;
}

async function getFuelTankCard(vehicleId, sensorId) {
	const options = [
		{
			name: "vehicleId",
			value: vehicleId
		},
		{
			name: "sensorId",
			value: sensorId
		}
	];

	const fuelTankCard = await apiService.get('fueltankCard/getFuelTankCard', options);

	return fuelTankCard;
}

async function updateFuelTankCard(fuelTankCard) {
	const response = await apiService.post('fueltankCard/updateFuelTankCard', fuelTankCard);
	return response;
}

async function downloadFuelTankCalibration(fileName, vehicleId, sensorId) {
	const parameters = {
		vehicleId: vehicleId,
		sensorId: sensorId
	}

	const result = await apiService.downloadFile('fueltankCard/downloadFuelTankCalibration', parameters, fileName);

	return result;
}

async function downloadSensorVerificationFile(fileName, vehicleId, sensorId) {
	const parameters = {
		vehicleId: vehicleId,
		sensorId: sensorId
	}

	const result = await apiService.downloadFile('fueltankCard/downloadSensorVerificationFile', parameters, fileName);

	return result;
}

async function downloadFuelConsumptionSensorVerificationFile(fileName, fuelConsumptionId, fuelConsumptionType) {
	const parameters = {
		fuelConsumptionId: fuelConsumptionId,
		fuelConsumptionType: fuelConsumptionType
	}

	const result = await apiService.downloadFile('fueltankCard/DownloadFuelConsumptionVerificationFile', parameters, fileName);

	return result;
}